import { Button, Card, CardContent, View } from "@/components/ui";
import TransactionHistoryCard from "@/components/shared/transaction-history-card";
import { EmptyCard } from "@/components/shared/empty-card";
import NoCredit from "@/assets/images/3d-illus/no-credit.png";
import type { ClientCreditAccountTransactions } from "@/types/profile";

export const CreditTransactionListCard = ({
  transactions,
  onViewMore,
}: {
  transactions: ClientCreditAccountTransactions;
  onViewMore?(): void;
}) => {
  const buttonText = "View more";

  return (
    <Card border="none">
      <CardContent className="p-0 md:p-4">
        {transactions.length ? (
          transactions.map((item) => (
            <TransactionHistoryCard key={item.id} transaction={item} icon />
          ))
        ) : (
          <EmptyCard
            src={NoCredit}
            title="No transaction yet"
            desc="Your payments history will show up here."
          />
        )}
        {onViewMore && !!transactions.length && (
          <View className="flex flex-col items-center">
            <Button
              variant="secondary"
              color="CTA2"
              size="lg"
              onClick={onViewMore}
            >
              {buttonText}
            </Button>
          </View>
        )}
      </CardContent>
    </Card>
  );
};
